/* eslint-disable eqeqeq */
import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import {
  AuthInput,
  AuthButton,
  Snackbar,
  Loading,
} from '../../components/index'
import { AuthApi } from '../../api/auth'
import { Errors } from '../../utilities/error'

const Register = () => {
  const router = useHistory()
  const [loading, setLoading] = useState(false)
  const handleSignUp = async (data) => {
    setLoading(true)
    localStorage.setItem('userMobile', data.mobile)
    await AuthApi.register(data)
      .then((res) => {
        setLoading(false)
        if (res.data.data.userSignup.code) {
          router.push('/registerVerification')
        }
      })
      .catch((err) => {
        if (err.response.data.errors[0].message == 'USER_INACTIVE') {
          localStorage.setItem('userMobile', data.mobile)
          router.push('/userVerification')
        } else {
          setLoading(false)
          Snackbar({
            title: 'نا موفق',
            message: Errors[err.response.data.errors[0].message],
            type: 'danger',
          })
        }
      })
  }
  return (
    <div className='container'>
      {loading && <Loading />}
      <div className='auth'>
        <div className='logo'>
          <Link to='/'>
            <img src='/images/logo.png' alt='logo' />
          </Link>
        </div>
        <div className='form-list'>
          <Formik
            initialValues={{
              fname: '',
              lname: '',
              mobile: '',
              password: '',
              type: 1,
            }}
            validationSchema={Yup.object({
              fname: Yup.string().required('نام خود را وارد کنید'),
              lname: Yup.string().required('نام خانوادگی را وارد کنید'),
              mobile: Yup.string()
                .min(11, 'فرمت شماره موبایل اشتباه است')
                .max(11, 'فرمت شماره موبایل اشتباه است')
                .required('شماره موبایل خود را وارد کنید'),
              password: Yup.string()
                .min(6, 'رمز عبور حداقل 6 کارکتر باشد')
                .required('رمز عبور خود را وارد کنید'),
            })}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              setTimeout(() => {
                handleSignUp(values)
                setSubmitting(false)
              }, 300)
            }}
          >
            {(props) => (
              <Form>
                <AuthInput
                  placeholder={'نام'}
                  name='fname'
                  type='text'
                  icon={
                    <img src='/svg/User.svg' className='icon-1' alt='user' />
                  }
                />
                <AuthInput
                  placeholder={'نام خانوادگی'}
                  name='lname'
                  type='text'
                  icon={
                    <img src='/svg/User.svg' className='icon-1' alt='user' />
                  }
                />
                <AuthInput
                  placeholder={'شماره همراه'}
                  name='mobile'
                  type='text'
                  icon={
                    <img
                      src='/svg/Calling.svg'
                      className='icon-1'
                      alt='calling'
                    />
                  }
                />
                <AuthInput
                  placeholder={'رمز عبور'}
                  name='password'
                  type='password'
                  icon={
                    <img
                      src='/svg/Password.svg'
                      className='icon-1'
                      alt='password'
                    />
                  }
                />
                <AuthButton title={'ساختن حساب کاربری'} />
              </Form>
            )}
          </Formik>
        </div>
        <div className='auth-link'>
          <div>
            <span>از قبل حساب کاربری دارید ؟</span>
            <Link to='/login'>وارد شوید</Link>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Register
